import { Component } from '@angular/core';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';

@Component({
  selector: 'app-network-event-management',
  imports: [FeatureHero],
  templateUrl: './network-event-management.html',
  styleUrl: './network-event-management.scss',
})
export class NetworkEventManagement {

}
